import appWrapperTypes from '../appWrapper/types';
import homepageTypes from '../homepage/types';

import data from './data';

const initialState = {
  user: {
    isLoggedIn: false,
  },
  totalMembers: null,
  totalAmountFinanced: null,
  amountPaidOut: null,
  total1031InvestmentAmount: null,
  ...data,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case appWrapperTypes.APP_INIT:
      return {
        ...state,
        user: {
          ...state.user,
          ...action.data.user,
        },
      };

    case appWrapperTypes.GET_USER_DATA_SUCCEEDED:
      return {
        ...state,
        user: action.user,
      };

    case homepageTypes.GET_TOKENS_SUCCEEDED:
      return {
        ...state,
        totalMembers: action.tokens.totalMembers,
        totalPropertyValueFinanced: action.tokens.totalPropertyValueFinanced,
        amountPaidOut: action.tokens.amountPaidOut,
        total1031InvestmentAmount: action.tokens.total1031InvestmentAmount,
      };

    default:
      return {
        ...state,
      };
  }
};
